import { SamEndpoint } from './config';
import { samSuccess } from './sam';

export default function fetchPRS(url, dispatch) {
  let samUrl = SamEndpoint;
  samUrl = `${SamEndpoint}/GetSamMessage`;
  return fetch(samUrl, { redirect: 'manual' })
    .then(data => data.json())
    .then((data) => {
      if (data && data.typeCode === 'SYSDOWN') {
        dispatch(samSuccess(data));
        return { sam: data };
      }

      if (data && data.typeCode === 'SYSWARN') {
        dispatch(samSuccess(data));
      }

      return fetch(url, { redirect: 'manual' })
        .then((response) => {
          if (response.type === 'opaqueredirect') {
            localStorage.removeItem('profileId');
            // A redirect typically means that the user needs to be logged in.
            // This is far from a clean way of handling this.
            // eslint-disable-next-line no-restricted-globals
            location.href = '/account/signout';
            return response;
          }
          return response.json();
        });
    });
}
